export default __webpack_public_path__ + "static/ELDP-S3-XXL-2ff00cf262801c5bcd7636215ac001e9.webp";